module.exports = __webpack_public_path__ + "static/media/pizzaria.2bfed50a.jpeg";